import { render, staticRenderFns } from "./main.vue?vue&type=template&id=675ed73d&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=675ed73d&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=675ed73d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ed73d",
  null
  
)

export default component.exports